import { ApiErrorMessage, BaseApi } from "api";
import { endpoints } from "config";
import { FarmDetails } from "./apiModels";

class FarmDetailsApi extends BaseApi {
  /**
   * Parse errors from `getFarmDetails`
   */
  private static getFarmDetailsParseError: typeof this.parseGenericErrorMessageCode =
    (msg) => {
      switch (msg) {
        // API-specific error codes here, generic messages handled below
        default:
          return this.parseGenericErrorMessageCode(msg);
      }
    };

  /**
   * # Get farm details for a panorama
   *
   * Gets basic information about the farm including its name, location, etc.
   */
  static getFarmDetails = async (panoramaGuid: string) => {
    try {
      const result = await this.makeRequest<FarmDetails, ApiErrorMessage[]>({
        url: endpoints.farmDetails.getPanoFields,
        method: "GET",
        config: {
          params: {
            panoramaGuid,
          },
        },
      });
      if (this.isResponseSuccessful(result)) {
        return this.successResponse(result.data.details);
      } else {
        return this.errorResponse(
          this.getFarmDetailsParseError(result.data.errors[0].message_code)
        );
      }
    } catch (err: unknown) {
      return this.safelyCatchUnknownError<FarmDetails>(
        err,
        "getFarmDetails",
        this.getFarmDetailsParseError
      );
    }
  };
}

export default FarmDetailsApi;
